<template>
  <div style="display:none;"></div>
</template>

<script>
import { ORGANIZATION, injectJsonLd } from '@/schema.config';

export default {
  name: 'CommonLocalBusinessSchemaComponent',
  mounted() {
    injectJsonLd('organization-schema', ORGANIZATION);
  },
};
</script>
